<div class="space-y-6">
  @if (isLoadingPlannings() && plannings().length === 0) {
    <div class="rounded-2xl border border-dashed border-border">
      <app-state-panel
        state="loading"
        title="Planungen werden geladen"
        description="Belegung, Wirtschaftlichkeit und Energiedaten werden vorbereitet."
      />
    </div>
  } @else {
    <app-analysis-plannings
      class="block"
      section="summary"
      [analysis]="analysis()"
      [plannings]="plannings()"
      [selectedPlanningId]="selectedPlanningId()"
      [primaryPlanningId]="primaryPlanningId()"
      [mode]="mode()"
      [isDeletingPlanning]="isDeletingPlanning()"
      [canCreatePlanning]="canCreatePlanning()"
      (selectedPlanningIdChange)="onSelectedPlanningIdChange($event)"
      (deletePlanning)="onDeletePlanning($event)"
      (setPrimaryPlanning)="onSetPrimaryPlanning($event)"
      (createPlanning)="onCreatePlanning()"
      (retryPlanning)="onRetryPlanning($event)"
    />

    @if (plannings().length > 0 && selectedPlanningIsCompleted()) {
      <div class="grid grid-cols-1 gap-10 xl:grid-cols-[minmax(0,1fr)_300px] xl:items-start">
        <app-analysis-plannings
          section="charts"
          [analysis]="analysis()"
          [plannings]="plannings()"
          [selectedPlanningId]="selectedPlanningId()"
          [primaryPlanningId]="primaryPlanningId()"
          [mode]="mode()"
          [isDeletingPlanning]="isDeletingPlanning()"
          [isVisible]="isVisible()"
          [chartDataProvider]="chartDataProvider()"
          (selectedPlanningIdChange)="onSelectedPlanningIdChange($event)"
          (deletePlanning)="onDeletePlanning($event)"
          (setPrimaryPlanning)="onSetPrimaryPlanning($event)"
        />

        <aside class="min-w-0 space-y-3">
          <div class="h-[260px] overflow-hidden rounded-lg border border-border bg-muted">
            <app-analysis-viewer
              [initialView]="planningViewerSelection"
              [analysis]="analysis()"
              [planningId]="selectedPlanningId()"
              [externalPolygons]="polygons()"
              [filesOverview]="filesOverview()"
              [visibleViews]="['map', '2d', '3d']"
              [expandable]="true"
              (expandRequested)="openViewerDialog($event)"
              (mediaRefreshRequested)="mediaRefreshRequested.emit()"
            />
          </div>

          <app-analysis-plannings
            section="template"
            [analysis]="analysis()"
            [plannings]="plannings()"
            [selectedPlanningId]="selectedPlanningId()"
            [primaryPlanningId]="primaryPlanningId()"
            [mode]="mode()"
            [isDeletingPlanning]="isDeletingPlanning()"
            (selectedPlanningIdChange)="onSelectedPlanningIdChange($event)"
            (deletePlanning)="onDeletePlanning($event)"
            (setPrimaryPlanning)="onSetPrimaryPlanning($event)"
          />
        </aside>
      </div>
    }
  }
</div>

<hlm-dialog [state]="viewerDialogState()" (closed)="closeViewerDialog()">
  <hlm-dialog-content
    *brnDialogContent="let ctx"
    class="h-[85vh] !w-[92vw] !max-w-[1400px] overflow-hidden p-0 [&>button]:z-[1100] [&>button]:rounded-lg [&>button]:bg-foreground/65 [&>button]:text-white"
  >
    <h2 hlmDialogTitle class="sr-only">Visualisierung</h2>
    <p hlmDialogDescription class="sr-only">Vergrößerte Darstellung der Analyse</p>
    <app-analysis-viewer
      [initialView]="expandedViewerSelection()"
      [analysis]="analysis()"
      [planningId]="selectedPlanningId()"
              [externalPolygons]="polygons()"
      [filesOverview]="filesOverview()"
      [visibleViews]="['map', '2d', '3d']"
      (mediaRefreshRequested)="mediaRefreshRequested.emit()"
    />
  </hlm-dialog-content>
</hlm-dialog>
